
import LocationOnlineStatusHandler from "./location-online-status-handler.vue";
import { mapState, mapGetters } from "vuex";
import ChannelOnlineStatusHandler from "../reciever/channel-online-status-handler.vue";
import { ALL_CHANNELS } from "@/constants/Channels.js";

export default {
  components: { LocationOnlineStatusHandler, ChannelOnlineStatusHandler },

  data() {
    return {
      loading: false,
      iconDimension: 25,
      iconOffset: 15
    };
  },
  props: {
    channel: {
      type: Object,
      default: {}
    }
  },
  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    ...mapGetters("reciever", ["getChannelAllOrders", "getLocationChannels"]),
    ...mapGetters("restaurant", ["hasMultipleBrands", "getLocationChannels"]),

    channelAllOrders() {
      return this.getChannelAllOrders(this.channel.name);
    },
    isAllChannelCol() {
      return this.channel.name === ALL_CHANNELS.name;
    }
  }
};
